PM.on("init.platinmarket", function() {

  $("div.pc_topla_urun_secim_icerik").each(function(){
    var hangi_label_alicam = $(this).attr("rel").replace("zorunlu_","")
    if(hangi_label_alicam > 0){
      var zorunlu_ismim = $("div [rel=pc_topla_urun_secim_icerik_"+hangi_label_alicam+"]").parent().find("div.pc_topla_grup_isim").text();
      $(this).html('<div class="urun_seciniz_zorunlu">Lütfen '+zorunlu_ismim+' seçiniz.</div>')
    }
  });

  function kilitle_ac(ust_id,urun_klas,recursiveCall){
    recursiveCall = (recursiveCall === true ? true : false);
    var ust_idim = ust_id ;
    var secili_urun = urun_klas;
    if(secili_urun != "urun"){

      $("#urun_ozellikler_urun_id_"+ust_idim).val(0);
      $("#urun_ozellikler_urun_stok_"+ust_idim).val(0);
      $("#urun_ozellikler_urun_fiyat_"+ust_idim).val(0);
      $("#urun_ozellikler_urun_kdv_"+ust_idim).val(0);
      $("#urun_ozellikler_alt_urun_id_"+ust_idim).val(0);

      var zorunlu_ismim = $("div [rel=pc_topla_urun_secim_icerik_"+ust_idim+"]").parent().find("div.pc_topla_grup_isim").text();

      $("div[rel=zorunlu_"+ust_idim+"]").each(function(){
        $(this).html('<div class="urun_seciniz_zorunlu">Lütfen '+zorunlu_ismim+' seçiniz.</div>')
        var simdiki_idim = $(this).parent("div").attr("rel").replace("pc_topla_urun_secim_icerik_","");
        $("#pc_toplama_urun_adet_"+simdiki_idim+" select").attr({"disabled":"disabled"});
        $("#pc_toplama_urun_adet_"+simdiki_idim+" label").addClass("inaktif");
        $("#urun_incele_"+simdiki_idim+" a").attr({"href":"javascript:void(0);"});
        $("#urun_incele_"+simdiki_idim+" a").removeAttr("target");
        $("#urun_ozellikler_urun_id_"+simdiki_idim).val(0);
        $("#urun_ozellikler_urun_stok_"+simdiki_idim).val(0);
        $("#urun_ozellikler_urun_fiyat_"+simdiki_idim).val(0);
        $("#urun_ozellikler_urun_kdv_"+simdiki_idim).val(0);
        $("#urun_ozellikler_alt_urun_id_"+simdiki_idim).val(0);
        kilitle_ac(simdiki_idim,'urun_seciniz', true);
      });
    }else{
      $("div[rel=zorunlu_"+ust_idim+"]").each(function(){
        $(this).html('<div class="urun_seciniz">Seçiniz.</div>')
        var simdiki_idim = $(this).parent("div").attr("rel").replace("pc_topla_urun_secim_icerik_","");
        $("#pc_toplama_urun_adet_"+simdiki_idim+" select").attr({"disabled":"disabled"});
        $("#pc_toplama_urun_adet_"+simdiki_idim+" label").addClass("inaktif");
        $("#urun_incele_"+simdiki_idim+" a").attr({"href":"javascript:void(0);"});
        $("#urun_incele_"+simdiki_idim+" a").removeAttr("target");
        $("#urun_ozellikler_urun_id_"+simdiki_idim).val(0);
        $("#urun_ozellikler_urun_stok_"+simdiki_idim).val(0);
        $("#urun_ozellikler_urun_fiyat_"+simdiki_idim).val(0);
        $("#urun_ozellikler_urun_kdv_"+simdiki_idim).val(0);
        $("#urun_ozellikler_urun_kdv_"+simdiki_idim).val(0);
        kilitle_ac(simdiki_idim,'urun_seciniz', true);
      });
    }
    if (recursiveCall === false) pc_topla_tutar_hesapla();
  }

  $("div.pc_topla_urun_secim").on('click', function(){
    if($(this).find("div div").attr("class") != "urun_seciniz_zorunlu"){
      var secimim = this;
      var bagli_oldugum_label = $(this).find("div.pc_topla_urun_secim_icerik").attr("rel").replace("zorunlu_","")
      if(bagli_oldugum_label > 0){
        var bagli_oldugum_label_urun_kriterleri = $("#urun_kriterlerim_"+bagli_oldugum_label).val();
      }else{
        var bagli_oldugum_label_urun_kriterleri = "";
      }
      var hangisini_sectim = $(this).attr("rel").replace("pc_topla_urun_secim_icerik_","");
      if($("#pc_topla_urunler_container_"+hangisini_sectim).css("display") != "block"){
        $("div.pc_topla_urunler_container").stop(true,true).hide();
        $("div.pc_topla_urun_secim").removeClass("secili");
        $(secimim).addClass("secili");
        $("#pc_topla_urunler_container_"+hangisini_sectim+" div.pc_topla_urunler_icerik").html('<div class="pc_topla_urunler_container_loading"></div>');
        $("#pc_topla_urunler_container_"+hangisini_sectim).show(0,function(){
          var gonderilecek_data = "sid="+ platinSid +"&label_id="+hangisini_sectim+"&uk="+bagli_oldugum_label_urun_kriterleri
          $("#pc_topla_urunler_container_"+hangisini_sectim+" div.pc_topla_urunler_icerik").load("/main/pc_wizard_data.asp?"+gonderilecek_data, function() {
            $("#pc_topla_urunler_container_"+hangisini_sectim+" div.pc_topla_urunler_icerik li").off("click").on('click', function(){

              var urun_ozelliklerim = $(this).attr("rel").replace("urunum_ozellikler_","").split("-");
              var urun_idim = urun_ozelliklerim[0];
              var urun_stogum = urun_ozelliklerim[1];
              var urun_fiyatim = urun_ozelliklerim[2];
              var urun_kdvm = urun_ozelliklerim[3];
              var urun_alt_utun_idim = urun_ozelliklerim[5];

              $("#urun_ozellikler_urun_id_"+hangisini_sectim).val(urun_idim);
              $("#urun_ozellikler_urun_stok_"+hangisini_sectim).val(urun_stogum);
              $("#urun_ozellikler_urun_fiyat_"+hangisini_sectim).val(urun_fiyatim);
              $("#urun_ozellikler_urun_kdv_"+hangisini_sectim).val(urun_kdvm);
              $("#urun_ozellikler_alt_urun_id_"+hangisini_sectim).val(urun_alt_utun_idim);

              $("#pc_toplama_urun_adet_"+hangisini_sectim+" select option:first").attr("selected","selected");

              if(urun_stogum > 0){
                $("#pc_toplama_urun_adet_"+hangisini_sectim+" select").prop("disabled", false);
                $("#pc_toplama_urun_adet_"+hangisini_sectim+" label").removeClass("inaktif");
                $("#pc_toplama_urun_adet_"+hangisini_sectim+" select").each(function(){
                  $("#pc_toplama_urun_adet_"+hangisini_sectim+" select option").each(function(i,j){
                    if(parseInt($(j).attr("value")) > urun_stogum){
                      $(j).attr({"disabled":"disabled"});
                    }else{
                      $(j).prop("disabled", false);
                    }
                  });
                });

              }else{
                $("#pc_toplama_urun_adet_"+hangisini_sectim+" select").attr({"disabled":"disabled"});
                $("#pc_toplama_urun_adet_"+hangisini_sectim+" label").addClass("inaktif");
              }

              $("#pc_topla_urunler_container_"+hangisini_sectim).hide(0,function(){$(secimim).removeClass("secili");});
              $(secimim).find("div.pc_topla_urun_secim_icerik").html($(this).html());
              if($(this).children(":first").attr("class") == "urun"){
                var urun_linkim = $(this).children("div.urun").children("div.urun_link").children("a").attr("href");
                $("#urun_incele_"+hangisini_sectim+" a").attr({"href":urun_linkim , "target":"_blank"});
              }else{
                $("#urun_incele_"+hangisini_sectim+" a").attr({"href":"javascript:void(0);"});
                $("#urun_incele_"+hangisini_sectim+" a").removeAttr("target");
              }

              //pc_topla_tutar_hesapla();

              kilitle_ac(hangisini_sectim,$(this).find("div").attr("class"));

            });
          });
        });
      }else{
        $("#pc_topla_urunler_container_"+hangisini_sectim).hide(0,function(){$("div.pc_topla_urun_secim").removeClass("secili");});
      }
    }else{
      alert($(this).find("div.urun_seciniz_zorunlu").text())
    }
  });

  $("select[name=urun_adet_2]").on('change', function(){
    $(this).parent().next().val($(this).val());
    pc_topla_tutar_hesapla();
  });

  function pc_topla_tutar_hesapla(){

    var d = new Date();
    var t = d.getDate();
    var gonderilecek_data = $("#pc_topla_frm").serialize();
    $.ajax({
      type: "POST",
      url: '/main/pc_wizard_tutar_hesapla.asp',
      data: gonderilecek_data ,
      success: function(data){
        $("div.toplam_fiyatlar").stop(true,true).html(data);
      },
      error: function(err,msg,thrownError){
        alert(err.responseText);
      }
    });
  }

  $("#pc_topla_email_gonder_btn").on('click', function(){

    var yazdir_icerik = "";
    yazdir_icerik = yazdir_icerik + '<html xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:w="urn:schemas-microsoft-com:office:word" xmlns:m="http://schemas.microsoft.com/office/2004/12/omml" xmlns="http://www.w3.org/TR/REC-html40"><head><meta http-equiv="Content-Type" content="text/html; charset=iso-8859-9" />'
    yazdir_icerik = yazdir_icerik + '</head><body style="margin:0 auto;"><div Style="padding:20px 0;">'
    yazdir_icerik = yazdir_icerik + '<div style="margin-bottom:20px"><img src="' + PM.Get("AppConfig", "SiteLogo") + '" /></div>'
    yazdir_icerik = yazdir_icerik + '<table cellspacing="0" cellpadding="10" width="100%" style="font:13px arial;border:1px solid silver;">'
    yazdir_icerik = yazdir_icerik + '<tr>'
    yazdir_icerik = yazdir_icerik + '<td align="left" width="200"><b>Ürün Tipi</b></td>'
    yazdir_icerik = yazdir_icerik + '<td align="left"><b>Ürün İsmi</b></td>'
    yazdir_icerik = yazdir_icerik + '<td align="right" style="text-align:right;" width="50"><b>Adet</b></td>'
    yazdir_icerik = yazdir_icerik + '<td align="right" style="text-align:right;" width="200"><b>Birim Fiyatı</b></td>'
    yazdir_icerik = yazdir_icerik + '</tr>'
    $("div.pc_topla_sol_grup").each(function(){
      if($(this).find(".pc_topla_urun_secim_icerik .urun").text() != ""){
        yazdir_icerik = yazdir_icerik + '<tr>'
        yazdir_icerik = yazdir_icerik + '<td style="border-top:1px solid silver;" align="left" width="200">'+$(this).find("div.pc_topla_grup_isim").html()+'</td>'
        yazdir_icerik = yazdir_icerik + '<td style="border-top:1px solid silver;" align="left">'+$(this).find("div.pc_topla_urun_secim_icerik div.urun_ismi").html()+'</td>'
        yazdir_icerik = yazdir_icerik + '<td style="border-top:1px solid silver;text-align:right;" align="right" width="50">'+$(this).find("input[name=urun_adet]").val()+'</td>'
        yazdir_icerik = yazdir_icerik + '<td style="border-top:1px solid silver;text-align:right;" align="right" width="200">'+$(this).find("div.pc_topla_urun_secim_icerik div.urun_stok_fiyat").html()+'</td>'
        yazdir_icerik = yazdir_icerik + '</tr>'
      }
    });
    yazdir_icerik = yazdir_icerik + '</table>'
    yazdir_icerik = yazdir_icerik + '<br/>'
    yazdir_icerik = yazdir_icerik + '<table cellspacing="0" cellpadding="10" width="100%">'
    $("div.toplam_fiyatlar table tr").each(function(){
      yazdir_icerik = yazdir_icerik + '<tr>'
      yazdir_icerik = yazdir_icerik + '<td style="text-align:right;padding:5px;margin:0;font:15px arial;">'+$(this).find("td.baslik").text()+'</td>'
      yazdir_icerik = yazdir_icerik + '<td style="text-align:right;padding:5px;margin:0;font:bold 15px arial;" width="100">'+$(this).find("td.deger").text()+'</td>'
      yazdir_icerik = yazdir_icerik + '</tr>'
    });
    yazdir_icerik = yazdir_icerik + '</table>'
    yazdir_icerik = yazdir_icerik + '<div style="margin-top:20px;padding:10px 0;border-top:1px solid silver;font:12px arial;color:#666;line-height:140%;">'
    yazdir_icerik = yazdir_icerik + '* Bu belge <b>'+ platinDateTime +'</b> tarihinde <b>'+ window.location.hostname +'</b> üzerinde oluşturulmuştur.<br/>'
    yazdir_icerik = yazdir_icerik + '* Yukarıda listelenen ürünlerin fiyatları ve stok durumları zamanla değişiklik gösterebilir. Lütfen sipariş vermeden önce tekrar kontrol ediniz.<br/>'
    if ($("div.pc_topla_doviz_kurlari").length && $("div.pc_topla_doviz_kurlari").attr("data-hidden") != "true") yazdir_icerik = yazdir_icerik + '* '+$("div.pc_topla_doviz_kurlari").html();
    yazdir_icerik = yazdir_icerik + '</div>'
    yazdir_icerik = yazdir_icerik + '</div></body></html>'

    $("#html2excell").val(yazdir_icerik);
    $(this).attr({"disabled":"disabled"});
    $("#pc_topla_excell_frm").attr({"action":"/main/pc_wizard_mail_gonder.asp?email="+$('#pc_topla_email_txt').val()});
    $("#pc_topla_excell_frm").trigger('submit');

  });

  $("#pc_topla_excell_btn").on('click', function(){
    var yazdir_icerik = "";
    yazdir_icerik = yazdir_icerik + '<html xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:w="urn:schemas-microsoft-com:office:word" xmlns:m="http://schemas.microsoft.com/office/2004/12/omml" xmlns="http://www.w3.org/TR/REC-html40"><head><meta http-equiv="Content-Type" content="text/html; charset=iso-8859-9" />'
    yazdir_icerik = yazdir_icerik + '</head><body style="margin:0 auto;"><div Style="padding:20px 0;">'
    yazdir_icerik = yazdir_icerik + '<div style="margin-bottom:20px"><img src="' + PM.Get("AppConfig", "SiteLogo") + '" /></div>'
    yazdir_icerik = yazdir_icerik + '<table cellspacing="0" cellpadding="10" width="100%" style="font:13px arial;border:1px solid silver;">'
    yazdir_icerik = yazdir_icerik + '<tr>'
    yazdir_icerik = yazdir_icerik + '<td align="left" width="200"><b>Ürün Tipi</b></td>'
    yazdir_icerik = yazdir_icerik + '<td align="left"><b>Ürün İsmi</b></td>'
    yazdir_icerik = yazdir_icerik + '<td align="right" style="text-align:right;" width="50"><b>Adet</b></td>'
    yazdir_icerik = yazdir_icerik + '<td align="right" style="text-align:right;" width="200"><b>Birim Fiyatı</b></td>'
    yazdir_icerik = yazdir_icerik + '</tr>'
    $("div.pc_topla_sol_grup").each(function(){
      if($(this).find(".pc_topla_urun_secim_icerik .urun").text() != ""){
        yazdir_icerik = yazdir_icerik + '<tr>'
        yazdir_icerik = yazdir_icerik + '<td style="border-top:1px solid silver;" align="left" width="200">'+$(this).find("div.pc_topla_grup_isim").html()+'</td>'
        yazdir_icerik = yazdir_icerik + '<td style="border-top:1px solid silver;" align="left">'+$(this).find("div.pc_topla_urun_secim_icerik div.urun_ismi").html()+'</td>'
        yazdir_icerik = yazdir_icerik + '<td style="border-top:1px solid silver;text-align:right;" align="right" width="50">'+$(this).find("input[name=urun_adet]").val()+'</td>'
        yazdir_icerik = yazdir_icerik + '<td style="border-top:1px solid silver;text-align:right;" align="right" width="200">'+$(this).find("div.pc_topla_urun_secim_icerik div.urun_stok_fiyat").html()+'</td>'
        yazdir_icerik = yazdir_icerik + '</tr>'
      }
    });
    yazdir_icerik = yazdir_icerik + '</table>'
    yazdir_icerik = yazdir_icerik + '<br/>'
    yazdir_icerik = yazdir_icerik + '<table cellspacing="0" cellpadding="10" width="100%">'
    $("div.toplam_fiyatlar table tr").each(function(){
      yazdir_icerik = yazdir_icerik + '<tr>'
      yazdir_icerik = yazdir_icerik + '<td style="text-align:right;padding:5px;margin:0;font:15px arial;">'+$(this).find("td.baslik").text()+'</td>'
      yazdir_icerik = yazdir_icerik + '<td style="text-align:right;padding:5px;margin:0;font:bold 15px arial;" width="50">'+$(this).find("td.deger").text()+'</td>'
      yazdir_icerik = yazdir_icerik + '</tr>'
    });
    yazdir_icerik = yazdir_icerik + '</table>'
    yazdir_icerik = yazdir_icerik + '<div style="margin-top:20px;padding:10px 0;border-top:1px solid silver;font:12px arial;color:#666;line-height:140%;">'
    yazdir_icerik = yazdir_icerik + '* Bu belge <b>'+ platinDateTime +'</b> tarihinde <b>'+ window.location.hostname +'</b> üzerinde oluşturulmuştur.<br/>'
    yazdir_icerik = yazdir_icerik + '* Yukarıda listelenen ürünlerin fiyatları ve stok durumları zamanla değişiklik gösterebilir. Lütfen sipariş vermeden önce tekrar kontrol ediniz.<br/>'
    if ($("div.pc_topla_doviz_kurlari").length && $("div.pc_topla_doviz_kurlari").attr("data-hidden") != "true") yazdir_icerik = yazdir_icerik + '* '+$("div.pc_topla_doviz_kurlari").html();
    yazdir_icerik = yazdir_icerik + '</div>'
    yazdir_icerik = yazdir_icerik + '</div></body></html>'

    $("#html2excell").val(yazdir_icerik);
    $("#pc_topla_excell_frm").attr({"action":"/main/pc_wizard_xls_cikti.asp"});
    $("#pc_topla_excell_frm").trigger('submit');
  });

  $("#pc_topla_yazdir_btn").on('click', function(){
    var win = window.open("", "pc_wizard_print","location=0,status=1,toolbar=1,resizable=1,scrollbars=1,width=1000,height=600");
    win.document.write("");
    var yazdir_icerik = "";
    yazdir_icerik = yazdir_icerik + '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd"><html xmlns="http://www.w3.org/1999/xhtml"><head><meta http-equiv="Content-Type" content="text/html; charset=iso-8859-9" />'
    yazdir_icerik = yazdir_icerik + '<style type="text/css">'
    yazdir_icerik = yazdir_icerik + 'div.toplam_fiyatlar{float:right;display:block;padding:10px 10px;border:1px solid silver;margin-top:10px;}'
    yazdir_icerik = yazdir_icerik + 'div.toplam_fiyatlar table tr td{text-align:right;padding:5px;font:bold 14px arial;}'
    yazdir_icerik = yazdir_icerik + 'div.toplam_fiyatlar table tr td.baslik{font-weight:normal;text-align:right;}'
    yazdir_icerik = yazdir_icerik + 'div.toplam_fiyatlar table tr td.deger{font-weight:bold;text-align:right;}'
    yazdir_icerik = yazdir_icerik + 'div.toplam_fiyatlar table tr.genel_toplam td{border-top:1px dotted darkred;color:red;}'
    yazdir_icerik = yazdir_icerik + 'div.toplam_fiyatlar table tr.genel_toplam td.baslik{font-weight:bold;}'
    yazdir_icerik = yazdir_icerik + 'table tr.genel_toplam td.deger{font-size:16px;}'
    yazdir_icerik = yazdir_icerik + 'div.toplam_fiyatlar table tr.havale td , div.toplam_fiyatlar table tr.tek_cekim td{color:darkgreen;}'
    yazdir_icerik = yazdir_icerik + 'div.toplam_fiyatlar table tr.havale td.baslik , div.toplam_fiyatlar table tr.tek_cekim td.baslik{font-weight:normal;}'
    yazdir_icerik = yazdir_icerik + 'div.toplam_fiyatlar table tr.havale td.deger , div.toplam_fiyatlar table tr.tek_cekim td.deger{font-size:15px;}'
    yazdir_icerik = yazdir_icerik + '</style>'
    yazdir_icerik = yazdir_icerik + '</head><body style="width:960px;margin:0 auto;"><div Style="padding:20px 0;">'
    yazdir_icerik = yazdir_icerik + '<div style="margin-bottom:20px"><img src="' + PM.Get("AppConfig", "SiteLogo") + '" /></div>'
    yazdir_icerik = yazdir_icerik + '<div style="border:1px solid silver;"><table cellspacing="0" cellpadding="10" width="100%" style="font:13px arial;padding:5px;">'
    yazdir_icerik = yazdir_icerik + '<tr>'
    yazdir_icerik = yazdir_icerik + '<td align="left"><b>Ürün Tipi</b></td>'
    yazdir_icerik = yazdir_icerik + '<td align="left"><b>Ürün İsmi</b></td>'
    yazdir_icerik = yazdir_icerik + '<td align="right"><b>Adet</b></td>'
    yazdir_icerik = yazdir_icerik + '<td align="right"><b>Birim Fiyatı</b></td>'
    yazdir_icerik = yazdir_icerik + '</tr>'
    $("div.pc_topla_sol_grup").each(function(){
      if($(this).find(".pc_topla_urun_secim_icerik .urun").text() != ""){
        yazdir_icerik = yazdir_icerik + '<tr>'
        yazdir_icerik = yazdir_icerik + '<td style="border-top:1px solid silver;" align="left">'+$(this).find("div.pc_topla_grup_isim").html()+'</td>'
        yazdir_icerik = yazdir_icerik + '<td style="border-top:1px solid silver;" align="left">'+$(this).find("div.pc_topla_urun_secim_icerik div.urun_ismi").html()+'</td>'
        yazdir_icerik = yazdir_icerik + '<td style="border-top:1px solid silver;" align="right">'+$(this).find("input[name=urun_adet]").val()+'</td>'
        yazdir_icerik = yazdir_icerik + '<td style="border-top:1px solid silver;" align="right">'+$(this).find("div.pc_topla_urun_secim_icerik div.urun_stok_fiyat").html()+'</td>'
        yazdir_icerik = yazdir_icerik + '</tr>'
      }
    });
    yazdir_icerik = yazdir_icerik + '</table></div><div class="toplam_fiyatlar">'
    yazdir_icerik = yazdir_icerik + $("div.toplam_fiyatlar").html()
    yazdir_icerik = yazdir_icerik + '</div><div style="clear:both;"></div>'
    yazdir_icerik = yazdir_icerik + '<div style="margin-top:20px;padding:10px 0;border-top:1px solid silver;font:12px arial;color:#666;line-height:140%;">'
    yazdir_icerik = yazdir_icerik + '* Bu belge <b>'+ platinDateTime +'</b> tarihinde <b>'+ window.location.hostname +'</b> üzerinde oluşturulmuştur.<br/>'
    yazdir_icerik = yazdir_icerik + '* Yukarıda listelenen ürünlerin fiyatları ve stok durumları zamanla değişiklik gösterebilir. Lütfen sipariş vermeden önce tekrar kontrol ediniz.<br/>'
    if ($("div.pc_topla_doviz_kurlari").length && $("div.pc_topla_doviz_kurlari").attr("data-hidden") != "true") yazdir_icerik = yazdir_icerik + '* '+$("div.pc_topla_doviz_kurlari").html();
    yazdir_icerik = yazdir_icerik + '</div>'
    yazdir_icerik = yazdir_icerik + '</div></body></html>'
    win.document.write(yazdir_icerik);
    win.print();
    var browserName=navigator.appName;
    if (browserName=="Microsoft Internet Explorer"){win.location.reload();}

  });

  $("#pc_topla_sepete_ekle_btn").on('click', function(){
    var sepete_ekle_urun_id = 0
    var sepete_ekle_urun_stok = 0
    $("input[name=urun_ozellikler_urun_id]").each(function(){
      sepete_ekle_urun_id = sepete_ekle_urun_id + parseInt($(this).val())
    });

    if(sepete_ekle_urun_id > 0){
      $("input[name=urun_ozellikler_urun_stok]").each(function(){
        sepete_ekle_urun_stok = sepete_ekle_urun_stok + parseInt($(this).val())
      });
      if(sepete_ekle_urun_stok > 0){
        if(confirm('Oluşturduğunuz yapılandırmayı sepete eklemek istediğinizden eminmisiniz?')){
          $("#pc_topla_frm").trigger('submit');
        }
      }else{
        alert('Stokta olmayan ürünleri sepete ekleyemezsiniz.');
      }
    }else{
      alert('Lütfen ürün seçiniz.');
    }
  });
});
